import styled from "styled-components";
import Button from "./Button";

const ButtonTopChild = styled(Button)`
  width: 100%;
  color: #393939;
  background-color: #ffffff;
`;
export default ButtonTopChild;
